import { get as _get } from 'lodash'

function DraggableBehavior() {  
  this.events = {    
    'mousedown':'dragstart',
    'touchstart':'dragstart',
    'touchmove':'dragmove',
    'touchend':'dragstop',
    'mouseup':'dragstop',
    'mousemove':'dragmove'
  }
}

DraggableBehavior.prototype.dragstart = function(btn, e) {
  // start the move, set up the origin
  // console.log('drag start');
  this.set('origin', e);
  this.getMap().set('draggable', false);  
  this.getMap().set('_noclicks', true);

  return false;
}

DraggableBehavior.prototype.dragmove = function(btn, e) {  
  let origin = this.get('origin');  

  if (origin) {
    // console.log('drag move');
    // if the drag has already started
    e.preventDefault();
    e.stopPropagation();

    
    // get the cursor/touch event x/y and convert to latlang coords on the map
    let left = _get(origin, 'targetTouches[0].clientX', origin.clientX) - _get(e, 'targetTouches[0].clientX', e.clientX),
        top = _get(origin, 'targetTouches[0].clientY', origin.clientY) - _get(e, 'targetTouches[0].clientY', e.clientY),
        pos = this.getProjection()
          .fromLatLngToDivPixel(this.get('position')),
        latLng = this.getProjection()
          .fromDivPixelToLatLng(new google.maps.Point(pos.x - left, pos.y - top));

    
    // reset the current origin to the current position
    this.set('origin', e);
    // update the overlay position
    this.set('position', latLng);
    // console.log('position: ' + this.get('position'));
    this.draw();
    
    return latLng;    
  }

  return false;
}

DraggableBehavior.prototype.dragstop = function(btn, e) {    
  // console.log('drag stop');
  this.getMap().set('_noclicks', false);
  
  if (this.get('origin')) {
    this.getMap().set('draggable', true);
    this.set('origin', null);  

    return this.get('position');  
  }

  return false;
}

DraggableBehavior.prototype.setup = function(btn) {
  let fn = (function (e) {
    if (this.get('origin')) {
      // Call handleOverlayEvent directly instead of relying on Vue emit
      this.handleOverlayEvent(e.type, btn, e);
    }
  }).bind(this);

  // Store reference to remove listeners later if needed
  if (!this._dragListeners) {
    this._dragListeners = [];
  }
  this._dragListeners.push({ fn, btn });

  // Use capture phase and add to document to ensure events are captured
  // even when mouse moves quickly outside the map div
  document.addEventListener('touchmove', fn, true);
  document.addEventListener('mousemove', fn, true);

  document.addEventListener('touchend', fn, true);
  document.addEventListener('mouseup', fn, true);
}

DraggableBehavior.prototype.handleEvent = function(eventName, e) {
  if (this.events[eventName]) {
    return this.events[eventName];    
  }
}

export default DraggableBehavior;